import React, { useContext } from "react";
import classnames from "classnames";

import { Event, Sport } from "@gp/models";
import { observer } from "mobx-react";
import { OfferOptionsContext } from "@gp/components";
import { useLiveMatchResult } from "@state/hooks/offer/useLiveMatchResult";

export const LiveMatchResult = observer(function LiveMatchResult(props: {
	isOnHomepage?: boolean;
	isEventFeatured?: boolean;
	isAdditionalOfferVisible?: boolean;
	event: Event;
	sport: Sport;
	isSpotlight?: boolean;
}) {
	const options = useContext(OfferOptionsContext);
	const { isScore, home, away } = useLiveMatchResult(
		props.event,
		props.sport,
		options
	);

	const {
		isEventFeatured,
		isAdditionalOfferVisible,
		isSpotlight,
	} = props;

	if (isSpotlight) {
		return (
			<>
				<div className="spotlight__match__home">{home}</div>
				<div className="spotlight__match__away">{away}</div>
			</>
		);
	}

	return (
		<div
			className={classnames("offer__body__data offer__result", {
				"offer__result--lrg":
					!isAdditionalOfferVisible && props.sport.abrv == "cricket",
				"offer__result--sml": isAdditionalOfferVisible,
				"is-score": isScore,
				"is-selected": isEventFeatured,
			})}
		>
			<div className="offer__result__team">{home}</div>
			<div className="offer__result__team">{away}</div>
		</div>
	);
});
